<div style="width: 97.5%;">
  <div class="col card-section ml-3 mt-3 p-5">
    <div class="d-flex">
      <div class="c100 p80 big">
          <span>
            <i class="fab fa-facebook fb-logo"></i>
            <p>{{ facebookReport.data.fanCount }} Likes &nbsp;&nbsp;&nbsp;&nbsp; {{ facebookReport.data.shares }} Shares</p>
          </span>
          <div class="slice">
              <div class="bar"></div>
              <div class="fill facebook"></div>
          </div>
      </div>

      <div class="c100 p40 big">
          <span>
            <i class="fab fa-youtube youtube-logo"></i>
            <p>{{ youtubeReport.data.viewCount }} Views &nbsp;&nbsp;&nbsp;&nbsp; {{ youtubeReport.data.subscriberCount }} Subscribers</p>
          </span>
          <div class="slice">
              <div class="bar"></div>
              <div class="fill youtube"></div>
          </div>
      </div>

      <div class="c100 p40 big">
          <span>
            <i class="fab fa-twitter twitter-logo"></i>
            <p>{{ twitterReport.data.statuses_count }} Tweets &nbsp;&nbsp;&nbsp;&nbsp; {{ twitterReport.data.followers_count }} Followers</p>
          </span>
          <div class="slice">
              <div class="bar"></div>
              <div class="fill twitter twitter-logo"></div>
          </div>
      </div>

      <div class="c100 p40 big">
        <span>
          <i class="fab fa-instagram ig-logo"></i>
          <p>700 Likes &nbsp;&nbsp;&nbsp;&nbsp; 20 Shares</p>
        </span>
        <div class="slice">
            <div class="bar"></div>
            <div class="fill instagram ig-logo"></div>
        </div>
      </div>

      <div class="c100 p40 big">
        <span>
          <i class="fab fa-linkedin linkedin-logo"></i>
          <p>20 Connections &nbsp;&nbsp;&nbsp; 20 #tags Followed</p>
        </span>
        <div class="slice">
            <div class="bar"></div>
            <div class="fill linkedin linkedin-logo"></div>
        </div>
      </div>
    </div>
  </div>
</div>
